var _path, _mask, _path2, _rect, _rect2, _rect3, _path3, _path4, _path5, _path6, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _mask2, _path7, _rect11, _rect12, _rect13, _rect14, _rect15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5H80C84.1421 0.5 87.5 3.85786 87.5 8V80C87.5 84.1421 84.1421 87.5 80 87.5H8C3.85786 87.5 0.5 84.1421 0.5 80V8C0.5 3.85786 3.85786 0.5 8 0.5Z",
    stroke: "#042761"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_176_345",
    maskUnits: "userSpaceOnUse",
    x: 27.3828,
    y: 31,
    width: 8,
    height: 32,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 27.3828,
    y: 31,
    width: 8,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3828 31H33.3828V63H29.3828V31Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3828 31H31.8828V63H33.3828H34.8828V31H33.3828ZM29.3828 63H30.8828V31H29.3828H27.8828V63H29.3828Z",
    fill: "#042761",
    mask: "url(#path-2-outside-1_176_345)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.8882,
    y: 17.25,
    width: 5.07447,
    height: 5.07447,
    stroke: "#042761",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.8242,
    y: 62.9097,
    width: 11.2021,
    height: 5.84043,
    stroke: "#042761",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.3564,
    y: 22.5691,
    width: 8.1383,
    height: 8.1383,
    stroke: "#042761",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3828 28.4255V35.1915",
    stroke: "#042761",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3828 25H65.3042L67.3828 28H35.3828",
    stroke: "#042761",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6172 25.2341H22.3831V28.298H27.6172",
    stroke: "#042761",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1753 68.7502H37.314V34.1565L38.2046 34.3274L55.5669 37.6458L56.1753 37.7629V68.7502Z",
    stroke: "#042761",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 56.4204,
    y: 40.6968,
    width: 11.7128,
    height: 28.0532,
    stroke: "#042761",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 41.3564,
    y: 40.4521,
    width: 5.5,
    height: 5.5,
    stroke: "#042761",
    strokeWidth: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 41.3564,
    y: 46.25,
    width: 5.5,
    height: 5.5,
    stroke: "#042761",
    strokeWidth: 1.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 41.3564,
    y: 52.0479,
    width: 5.5,
    height: 5.5,
    stroke: "#042761",
    strokeWidth: 1.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 41.4946,
    y: 61.25,
    width: 5.5,
    height: 7.5,
    stroke: "#042761",
    strokeWidth: 1.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 46.6328,
    y: 40.4521,
    width: 5.5,
    height: 5.5,
    stroke: "#042761",
    strokeWidth: 1.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 59.6328,
    y: 46.25,
    width: 5.5,
    height: 5.5,
    stroke: "#042761",
    strokeWidth: 1.5
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-18-outside-2_176_345",
    maskUnits: "userSpaceOnUse",
    x: 58.3828,
    y: 34,
    width: 8,
    height: 6,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 58.3828,
    y: 34,
    width: 8,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3828 36H64.3828V40H60.3828V36Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3828 36V34.5H58.8828V36H60.3828ZM64.3828 36H65.8828V34.5H64.3828V36ZM60.3828 36V37.5H64.3828V36V34.5H60.3828V36ZM64.3828 36H62.8828V40H64.3828H65.8828V36H64.3828ZM60.3828 40H61.8828V36H60.3828H58.8828V40H60.3828Z",
    fill: "#042761",
    mask: "url(#path-18-outside-2_176_345)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 46.6328,
    y: 46.25,
    width: 5.5,
    height: 5.5,
    stroke: "#042761",
    strokeWidth: 1.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 59.6328,
    y: 52.0479,
    width: 5.5,
    height: 5.5,
    stroke: "#042761",
    strokeWidth: 1.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 46.6328,
    y: 52.0479,
    width: 5.5,
    height: 5.5,
    stroke: "#042761",
    strokeWidth: 1.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 59.6328,
    y: 57.8457,
    width: 5.5,
    height: 5.5,
    stroke: "#042761",
    strokeWidth: 1.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 46.4946,
    y: 61.25,
    width: 5.5,
    height: 7.5,
    stroke: "#042761",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpIcon2);
export default __webpack_public_path__ + "static/media/expIcon2.3ee93882e54341dfc5801dfabd44666d.svg";
export { ForwardRef as ReactComponent };